import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Hotelinfo, Ota } from 'frontend-utils/models';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';

export default class Rankingsummary extends Model {
  [Type] = 'rankingsummary' as const;

  @belongsTo('hotelinfo', { async: false, inverse: null })
  declare hotelinfo: Hotelinfo;

  @belongsTo('ota', { async: false, inverse: null })
  declare ota: Ota;

  @attr('number') declare availableHotels: number;
  @attr('dayjs') declare extractDatetime: NonNullable<DayjsTransformReturn>;
  @attr('string') declare granularity: string;
  @attr('string') declare message: string;
  @attr('number') declare ranking: number;
  @attr('number') declare reviews: number;
  @attr('number') declare reviewScore: number;

  get integerDate(): number {
    return Math.floor(this.extractDatetime.unix() / 86400);
  }
}
